export default __webpack_public_path__ + "static/media/sibling-rivalry@2x 6.9db831df.png";